import View from "./View";
import icons from "url:../../img/icons.svg";

class PaginationView extends View {
  _parentElement = document.querySelector(".pagination");
  // this._data == data passed into render(inherited from View), called from controller with paginationView context
  //this._data gets passed into paginationView.render(data)
  //this._data === the result of model.getSearchResultsPage() in controller
  addHandlerClick(handler) {
    this._parentElement.addEventListener("click", function (e) {
      const btn = e.target.closest(".btn--inline");

      if (!btn) return;
      const goToPage = +btn.dataset.goto;

      handler(goToPage);
    });
  }

  _generateMarkup() {
    const currentPage = this._data.page;
    const numPages = Math.ceil(
      this._data.results.length / this._data.resultsPerPage
    );

    //these two functions are responsible for generating each pagination html string
    const _generatePreviousPageMarkup = () =>
      `
      <button data-goto="${
        currentPage - 1
      }" class="btn--inline pagination__btn--prev">
        <span> Page ${currentPage - 1}</span>
        <svg class="search__icon">
         <use href="${icons}#icon-arrow-left"></use>
      </svg>
    </button> 
      `;
    const _generateNextPageMarkup = () =>
      `
        <button data-goto="${
          currentPage + 1
        }"class="btn--inline pagination__btn--next">
          <span>Page ${currentPage + 1}</span>
          <svg class="search__icon">
           <use href="${icons}#icon-arrow-right"></use>
        </svg>
      </button> 
        `;

    // Page 1, and there are other pages
    if (currentPage === 1 && numPages > 1) {
      return _generateNextPageMarkup();
    }

    // Last page

    if (currentPage === numPages && numPages > 1) {
      return _generatePreviousPageMarkup();
    }

    //Other page
    if (currentPage < numPages) {
      return _generatePreviousPageMarkup() + _generateNextPageMarkup(); // concatenating two returned strings
    }

    // Page 1, and there are no other pages
    return "";
  }
}

export default new PaginationView();

// state = {
//   recipe: {},
//   search: {
//     query: "",
//     results: [],
//     page: 1,
//     resultsPerPage: RESULTS_PER_PAGE,
//   },
// };
